import { AxiosPromise, AxiosStatic } from "axios";
import {
  ClientReallocationQuote,
  ClientTransitionQuote,
  ClientTransitionRequest,
  CreateTransitionRequestInput,
} from "../types/ClientTransitionRequest";

export const findTransitionRequestById =
  (serverURL: string, appAxios: AxiosStatic) =>
  async (id: string): AxiosPromise<ClientTransitionRequest> =>
    await appAxios.get(`${serverURL}/transition-requests/${id}`, {
      withCredentials: true,
    });

export const getTransitionQuote =
  (serverURL: string, appAxios: AxiosStatic) =>
  async (commitmentId: string): AxiosPromise<ClientTransitionQuote> =>
    await appAxios.get(`${serverURL}/transition-requests/quote`, {
      params: { commitmentId },
      withCredentials: true,
    });

export const getReallocationQuote =
  (serverURL: string, appAxios: AxiosStatic) =>
  async (commitmentId: string): AxiosPromise<ClientReallocationQuote> =>
    await appAxios.get(`${serverURL}/transition-requests/reallocation-quote`, {
      params: { commitmentId },
      withCredentials: true,
    });

export const createTransitionRequest =
  (serverURL: string, appAxios: AxiosStatic) =>
  async (
    input: CreateTransitionRequestInput
  ): AxiosPromise<ClientTransitionRequest> =>
    await appAxios.post(`${serverURL}/transition-requests`, input, {
      withCredentials: true,
    });

export const cancelTransitionRequest =
  (serverURL: string, appAxios: AxiosStatic) =>
  async (id: string): AxiosPromise<ClientTransitionRequest> =>
    await appAxios.post(
      `${serverURL}/transition-requests/${id}/cancel`,
      undefined,
      { withCredentials: true }
    );
